import { AlertVariants } from '../data';

import Danger from '@quick/components/img/danger.svg';
import Info from '@quick/components/img/info.svg';
import Success from '@quick/components/img/success.svg';
import Warning from '@quick/components/img/warning.svg';

/* Select component for DEFAULT key */
const alertTypes = {
  [AlertVariants.SUCCESS]: Success,
  [AlertVariants.DANGER]: Danger,
  [AlertVariants.INFO]: Info,
  [AlertVariants.WARNING]: Warning,
  [AlertVariants.DEFAULT]: Success,
};

export { alertTypes };
